import { render, staticRenderFns } from "./guard_config_list.vue?vue&type=template&id=31b952b9"
import script from "./guard_config_list.vue?vue&type=script&lang=js"
export * from "./guard_config_list.vue?vue&type=script&lang=js"
import style0 from "./guard_config_list.vue?vue&type=style&index=0&id=31b952b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports